<template>
  <div v-if="userSession?._id">
    <UserAvatar
      v-if="userSession.email"
      class="rounded-full"
      :email="userSession.email"
    ></UserAvatar>
    {{ username }}
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { userSession } from "./user-session";
import UserAvatar from "./components/UserAvatar.vue";

const username = computed(() => {
  return userSession.value?.username;
});
</script>
